<template>
  <div class="bg-white">

    <!-- <Head></Head> -->
    <section class="w">
      <div class="part">
        <p>{{ $t('commodity.Components.ReturnRefund.Tips1') }}</p>
      </div>
      <div class="part">
        <h2>{{ $t('commodity.Components.ReturnRefund.Accept') }}:</h2>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips2') }}</p>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips3') }}</p>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips4') }}</p>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips5') }}</p>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips6') }}</p>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips7') }}</p>
      </div>
      <div class="part">
        <h2>{{ $t('commodity.Components.ReturnRefund.Tips8') }}</h2>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips9') }}</p>
      </div>
      <div class="part">
        <h2>{{ $t('commodity.Components.ReturnRefund.Tips10') }}</h2>
        <ul>
          <li>{{ $t('commodity.Components.ReturnRefund.Tips11') }}</li>
          <li>{{ $t('commodity.Components.ReturnRefund.Tips12') }}</li>
          <li>{{ $t('commodity.Components.ReturnRefund.Tips13') }}</li>
          <li>{{ $t('commodity.Components.ReturnRefund.Tips14') }}</li>
          <li>{{ $t('commodity.Components.ReturnRefund.Tips15') }}</li>
        </ul>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips16') }}</p>
      </div>
      <div class="part">
        <h2>{{ $t('commodity.Components.ReturnRefund.Tips17') }}</h2>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips18') }}</p>
      </div>
      <div class="part">
        <h2>{{ $t('commodity.Components.ReturnRefund.Tips19') }}</h2>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips20') }}</p>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips21') }}</p>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips22') }}</p>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips23') }}</p>
      </div>
      <div class="part">
        <h2>{{ $t('commodity.Components.ReturnRefund.Tips24') }}</h2>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips25') }}</p>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips26') }}</p>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips27') }}</p>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips28') }}</p>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips29') }}</p>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips30') }}</p>
      </div>
      <div class="part">
        <h2>{{ $t('commodity.Components.ReturnRefund.Tips31') }}</h2>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips32') }}</p>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips33') }}</p>
        <p>{{ $t('commodity.Components.ReturnRefund.Tips34') }}</p>
      </div>
      <div class="part">
        <h2>{{ $t('commodity.Components.ReturnRefund.Tips35') }}</h2>
        <p style="line-height:32px" class="f">
          <img style="margin:5px 5px 0 0;height:22px;line-height:22px" src="@/assets/img/homePage/mail.svg" alt="" lazy  />
          <span>info@KakaClo.com</span>
        </p>
        <p style="line-height:32px" class="f">
          <i style="margin:5px 5px 0 0;font-size:22px;line-height:22px" class="iconfont icon-phone-line"></i>
          <span>+1 626 866 2112</span>
        </p>
        <!-- <p style="line-height:32px" class="f">
          <img style="height:22px;margin-right:5px;margin-top:5px" src="@/assets/img/homePage/map-icon.svg" alt="" lazy  />
          <span>19H Maxgrand plaza,No.3 Tai Yau Strect,San Po Kong, Kowloon,Hong Kong</span>
        </p> -->
      </div>
    </section>
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
// import Head from '../components/Head.vue'
// import Footer from '../components/Footer.vue'
export default {
  name: 'refundInformation',
  // components: { Head, Footer },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import '@/views/home/css/term.scss';
</style>
